module.exports = __webpack_public_path__ + "static/img/bah.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bah.png
// module id = GcC8
// module chunks = 20